import { Module } from "vuex";

export const FeeTrackingCCDV: Module<any, any> = {
  state: {
    queryFeeTrackingCCDV: {
      company_ids: [],
      cpn_code: [],
      quarter: null,
      year: null,
      businessCpn: [],
      network_type: [],
      lic_number: [],
      fromDay: null,
      toDay: null,
      isCheckCpn: false,
      statuses: [],
    },
  },
  getters: {
    queryFeeTrackingCCDV: (state) => state.query,
  },
  mutations: {
    setqueryFeeTrackingCCDV(state, data) {
      state.queryflowdata = data;
    },
  },
  actions: {
    setqueryFeeTrackingCCDV(query) {
      query.commit("setqueryFeeTrackingCCDV");
    },
  },
};
